import React from 'react';
import { Image, Text, View } from 'react-native-web';
import { img_expand, scan_barcode } from '../../../../utils/ImagesManagementUtils';

//= ========================================================================

const MethodCard = ({
  globJSON, text, isBlueBorder, showOneMethod, source,
}) => {
  const { colors } = globJSON.configurations.theme;
  const isScanIcon = source === scan_barcode;
  const myStyles = {
    card: {
      marginHorizontal: 16,
      marginTop: showOneMethod ? 24 : 12,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 4 : 9,
      border: isBlueBorder ? `solid 1.8px ${colors.primary_cta_color}` : `solid 1px ${colors.border_color}`,
      flexDirection: 'row',
      minHeight: 40,
      boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.1)',
    },
    text: {
      fontSize: 11.6,
      tintColor: colors.cta_font_color,
      marginVertical: 'auto',
      marginLeft: 2,
    },
    iconBackground: {
      width: 30,
      height: 30,
      borderRadius: 3.5,
      backgroundColor: colors.menu_top_area_color,
      margin: 7,
      paddingLeft: isScanIcon ? 6 : 7,
      paddingTop: isScanIcon ? 6 : 4,
    },
    iconInsideBox: {
      height: isScanIcon ? 18 : 22,
      width: isScanIcon ? 18 : 16,
    },
    iconExpand: {
      marginVertical: 'auto',
      height: 7,
      width: 7,
    },
    textContainer: {
      justifyContent: 'space-between',
      flexDirection: 'row',
      width: 150,
    },
  };

  return (
    <View style={myStyles.card}>
      <View style={myStyles.iconBackground}>
        <Image
          fadeDuration={0}
          style={myStyles.iconInsideBox}
          source={source}
        />
      </View>
      <View style={myStyles.textContainer}>
        <Text style={myStyles.text}>{text}</Text>
        <Image
          fadeDuration={0}
          style={myStyles.iconExpand}
          source={img_expand}
        />
      </View>
    </View>
  );
};
export default MethodCard;
